export default __webpack_public_path__ + "static/no-image-51027ae2b1f30de7a85be8ef11f92f2b.webp";